import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography, Paper, IconButton, Tooltip, Button, Modal, TextField, Grid, InputAdornment } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
// import '../styles/user.css';
import { toast, ToastContainer } from 'react-toastify'; // Import Toastify
import 'react-toastify/dist/ReactToastify.css'; // Import Toastify styles
import { authToken } from '../globals/Global';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { getuser, adduser, deluser, updateuser, getuserbyid } from '../globals/Services';

// Fixed modal styles using flexbox centering
const modalContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const modalContentStyle = {
  width: 600,
  maxWidth: '90vw',
  bgcolor: 'background.paper',
  border: '2px solid #ccc',
  boxShadow: 24,
  p: 5,
  outline: 'none',
  borderRadius: 2,
  maxHeight: '90vh',
  overflow: 'auto',
};

const editModalContentStyle = {
  width: 1000,
  maxWidth: '95vw',
  bgcolor: 'background.paper',
  border: '2px solid #ccc',
  boxShadow: 24,
  p: 5,
  outline: 'none',
  borderRadius: 2,
  maxHeight: '90vh',
  overflow: 'auto',
};

export default function UserManagement() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState({
  firstName: '',
  lastName: '',
  roles: 'USER',
  phoneNo: '',
  email: '',
  dob: null, // Use dayjs
  tob: null,
  gender: '',
  pob: '',
  country: '',
  });

  const [deleteUserId, setDeleteUserId] = useState(null);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [importing, setImporting] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const [editData, setEditData] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = authToken || localStorage.getItem('sessionToken');
        const response = await axios.get(getuser, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        
        const mappedData = response.data
        ?.filter(user => user.roles === 'USER')
        .map((item, index) => ({
          id: item.userId || index,
          fullName: `${item.firstName || ''} ${item.lastName || ''}`.trim(),
          mobile: item.phoneNo || 'N/A',
          email: item.email || 'N/A',
          status: item.status || 'N/A',
          createdAt: item.createdAt
            ? dayjs(item.createdAt).format('DD-MM-YYYY')
            : 'N/A',
          createdAtTimestamp: item.createdAt // Add this for sorting
        })) || [];

            mappedData.sort((a, b) => a.id - b.id);
            setUsers(mappedData);
          } catch (error) {
            console.error('Failed to fetch users:', error);
            setUsers([]);
          } finally {
            setLoading(false);
          }
        };

    fetchUsers();
  }, []);

  const handleAddUser = async () => {
  try {
    const token = authToken || localStorage.getItem('sessionToken');

    const dataToSend = {
      ...formData,
      dob: formData.dob ? dayjs(formData.dob).format('YYYY-MM-DD') : '',
      tob: formData.tob ? dayjs(formData.tob).format('hh:mm:ss A') : '',
      phoneNo: `+91 ${formData.phoneNo}`,
    };

    const response = await axios.post(adduser, dataToSend, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (response.status === 200 || response.status === 201) {
      toast.success('User added successfully!'); // Toast notification
      setOpenModal(false);
      setFormData({
        firstName: '',
        lastName: '',
        roles: 'USER',
        phoneNo: '',
        email: '',
        dob: null,
        tob: null,
        gender: '',
        pob: '',
        country: '',
      });
    } else {
      toast.error('Failed to add user'); // Toast notification for error
    }
  } catch (err) {
    console.error('Add user error:', err);
    toast.error('Error adding user'); // Toast notification for error
  }
};

  const handleDelete = (id, fullName) => {
    setDeleteUserId(id);
    setConfirmationMessage(`Are you sure you want to delete user: ${fullName}?`);
    setConfirmationModalOpen(true);
  };

  const confirmDelete = async () => {
    try {
      const token = authToken || localStorage.getItem('sessionToken');
  
      const response = await axios.post(
        deluser,   // Correct backend URL
        {
          userId: deleteUserId
         
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
  
      if (response.status === 200) {
        setUsers(prev =>
          prev.map(user =>
            user.id === deleteUserId ? { ...user, status: 'INACTIVE' } : user
          )
        );
        toast.success('User marked as Inactive successfully'); // Success notification
      } else {
        toast.error('Error updating user status'); // Error notification
      }
    } catch (error) {
      console.error('Error updating user status:', error);
      toast.error('Failed to update user status'); // Error notification
    }
    setConfirmationModalOpen(false);
  };
  

  const handleEdit = async (id) => {
    try {
      const token = authToken || localStorage.getItem('sessionToken');
      const response = await axios.get(getuserbyid(id), {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
  
      const data = response.data || {};
  
      setEditData({
        firstName: data.data.firstName || '',
        lastName: data.data.lastName || '',
        email: data.data.email || '',
        dob: data.data.dob || '',
        tob: data.data.tob || '',
        pob: data.data.pob || '',
        country: data.data.country || '',
        state: data.data.state || '',
        city: data.data.city || '',
        zipcode: data.data.zipcode || '',
        status: data.data.status || '', // Default to ACTIVE
        mobile: data.data.phoneNo || '',
        userId: id
      });
  
      setEditModalOpen(true);
    } catch (err) {
      console.error('Failed to fetch user:', err);
      toast.error('Unable to load user details.'); // Error notification
    }
  };
  
  const handleUpdateUser = async () => {
    try {
      const token = authToken || localStorage.getItem('sessionToken');
  
      const response = await axios.put(
        updateuser(editData.userId), // Use the function to get the correct URL
        editData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      // console.log('Update Response:', updateuser(editData.userId)); // Debugging line
  
      if (response.status === 200) {
        toast.success('User updated successfully'); // Success notification
  
        // Update local copy—including the status—from your edit form
        setUsers(prev =>
          prev.map(user =>
            user.id === editData.userId
              ? {
                  ...user,
                  fullName: `${editData.firstName} ${editData.lastName}`,
                  email: editData.email,
                  status: editData.status,      // ← add this
                  mobile: editData.phoneNo || user.mobile // if you allow editing phone
                }
              : user
          )
        );
  
        setEditModalOpen(false);
      } else {
        toast.error('Update failed'); // Error notification
      }
    } catch (error) {
      console.error('Update error:', error);
      toast.error('Something went wrong while updating the user'); // Error notification
    }
  };

  const handleImportUsers = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  try {
    setImporting(true);
    const token = authToken || localStorage.getItem('sessionToken');
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(
      'http://stg.panditjee.com:8080/api/users/import',
      formData,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (response.data?.status === 'SUCCESS') {
      const imported = response.data.data || [];
      toast.success(`${imported.length} user(s) imported successfully!`);

      // Append newly imported users to the table
      const newUsers = imported.map((item) => ({
        id: item.userId,
        fullName: `${item.firstName || ''} ${item.lastName || ''}`.trim(),
        mobile: item.phoneNo || 'N/A',
        email: item.email || 'N/A',
        status: item.status || 'N/A',
        createdAt: item.createdAt ? dayjs(item.createdAt).format('DD-MM-YYYY') : 'N/A',
        createdAtTimestamp: item.createdAt,
      }));

      setUsers((prev) => [...prev, ...newUsers]);
    } else {
      toast.error('Import failed. Please check the file and try again.');
    }
  } catch (err) {
    console.error('Import error:', err);
    toast.error('Error importing users.');
  } finally {
    setImporting(false);
    // Reset the input so the same file can be re-uploaded if needed
    e.target.value = '';
  }
};

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const columns = [
    {
      field: 'id', headerName: 'ID', width: 80, headerAlign: 'center', align: 'center',
      renderHeader: () => <strong>ID</strong>
    },
    {
      field: 'fullName', headerName: 'Full Name', flex: 1, headerAlign: 'center', align: 'center',
      renderHeader: () => <strong>Full Name</strong>
    },
    {
      field: 'mobile', headerName: 'Mobile', flex: 1, headerAlign: 'center', align: 'center',
      renderHeader: () => <strong>Mobile</strong>
    },
    {
      field: 'email', headerName: 'Email ID', flex: 1.5, headerAlign: 'center', align: 'center',
      renderHeader: () => <strong>Email ID</strong>
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderHeader: () => <strong>Status</strong>,
      renderCell: (params) => {
        // Convert status to lowercase and capitalize the first letter
        const statusFormatted = params.value.toLowerCase().charAt(0).toUpperCase() + params.value.slice(1).toLowerCase();

        return (
        <Typography
        sx={{
        color: params.value === 'ACTIVE' ? 'green' : (params.value === 'INACTIVE' ? 'red' : 'grey'),
        fontWeight: 'bold',
        fontSize: '14px',
        textAlign: 'center',
        justifyContent: 'center',
        margin: '15px 0px 0px 0px',
        }}
        >
      {statusFormatted} {/* Display formatted status */}
      </Typography>
      );
      },

    },
    
    {
      field: 'delete',
      headerName: 'Delete',
      width: 100,
      headerAlign: 'center',
      align: 'center',
      renderHeader: () => <strong>Delete</strong>,
      renderCell: (params) => (
        <Tooltip title="Delete">
          <IconButton onClick={() => handleDelete(params.row.id, params.row.fullName)} size="small" color="error">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      )
    },
    {
      field: 'createdAt',
      headerName: 'Date',
      width: 130,
      headerAlign: 'center',
      align: 'center',
      renderHeader: () => <strong>Date</strong>,
      sortComparator: (v1, v2, param1, param2) => {
        // Use the timestamp for sorting
        const date1 = param1.api.getRow(param1.id)?.createdAtTimestamp;
        const date2 = param2.api.getRow(param2.id)?.createdAtTimestamp;
        
        if (!date1) return 1;
        if (!date2) return -1;
        
        return new Date(date1) - new Date(date2);
      }
    },
    {
      field: 'edit',
      headerName: 'Edit',
      width: 100,
      headerAlign: 'center',
      align: 'center',
      renderHeader: () => <strong>Edit</strong>,
      renderCell: (params) => (
        <Tooltip title="Edit">
          <IconButton onClick={() => handleEdit(params.row.id)} size="small" color="primary">
            <EditIcon />
          </IconButton>
        </Tooltip>
      )
    }
  ];
  return (
    <Box className="user-table-container"
    sx={{
        pt: 3,    // padding-top
        pr: 3,    // padding-right
        pb: 3,    // padding-bottom
        pl: 3,    // padding-left
      }}
      >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
  <Typography variant="h5" fontWeight="600">User Management</Typography>

    <Box display="flex" gap={2} alignItems="center">
      {/* Hidden file input */}
      <input
        type="file"
        id="bulk-import-input"
        accept=".csv,.xlsx,.xls"
        style={{ display: 'none' }}
        onChange={handleImportUsers}
      />

      {/* Bulk Import Button */}
      <Button
        variant="outlined"
        color="primary"
        disabled={importing}
        onClick={() => document.getElementById('bulk-import-input').click()}
        sx={{
          minWidth: '140px',
          fontWeight: 'bold',
          textTransform: 'none',
        }}
      >
        {importing ? 'Importing...' : '⬆ Bulk Import'}
      </Button>

      {/* Existing Add User Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpenModal}
        sx={{
          minWidth: '100px',
          fontWeight: 'bold',
          textTransform: 'none',
        }}
      >
        + Add User
      </Button>
    </Box>
  </Box>
      <Paper elevation={2}>
        <Box sx={{ width: '100%', overflowX: 'auto' }}>
            <div style={{ minWidth: '600px', height: 430 }}>
            {loading ? (
              <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography>Loading users...</Typography>
              </Box>
            ) : users.length === 0 ? (
              <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography>No users found.</Typography>
              </Box>
            ) : (
              <DataGrid
                rows={users}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: pageSize }
                  }
                }}
                pageSizeOptions={[10, 25, 50]} // ✅ Updated prop name
                pagination
                disableSelectionOnClick
                getRowId={(row) => row.id}
                // disableColumnMenu
                sx={{ height: '100%' }}
                onPaginationModelChange={(model) => {
                  setPageSize(model.pageSize);
                }}
              />
            )}
          </div>
        </Box>
      </Paper>

      {/* Confirmation Modal - FIXED POSITIONING */}
      <Modal 
        open={confirmationModalOpen} 
        onClose={() => setConfirmationModalOpen(false)}
        sx={modalContainerStyle}
        container={document.body}
        disablePortal={false}
      >
        <Box sx={modalContentStyle}>
          <Typography variant="h6" mb={2}>Confirm Delete</Typography>
          <Typography variant="body2" mb={3}>{confirmationMessage}</Typography>
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button variant="outlined" onClick={() => setConfirmationModalOpen(false)} sx={{ mr: 2 }}>Cancel</Button>
            <Button variant="contained" color="error" onClick={confirmDelete}>Confirm</Button>
          </Box>
        </Box>
      </Modal>

      {/* Add User Modal - FIXED POSITIONING */}
      <Modal 
        open={openModal} 
        onClose={handleCloseModal} 
        aria-labelledby="add-user-modal" 
        aria-describedby="form-to-add-user"
        sx={modalContainerStyle}
        container={document.body}
        disablePortal={false}
      >
      <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 850,
      maxHeight: '90vh',
      overflowY: 'auto',
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
      }}>

      <Typography variant="h6" mb={2}>Add User</Typography>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Grid container spacing={2}>
          {/* First Row: 3 Columns */}
          <Grid item xs={12} sm={4}>
            <TextField 
              fullWidth label="First Name" name="firstName" value={formData.firstName} onChange={handleInputChange} 
              sx={{
                width: '250px',
                height: '56px',
                minHeight: '56px',                    
              }}
              />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField 
              fullWidth label="Last Name" name="lastName" value={formData.lastName} onChange={handleInputChange} 
              sx={{
                width: '250px',
                height: '56px',
                minHeight: '56px',                    
              }}
              />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth label="Phone No" name="phoneNo" value={formData.phoneNo} onChange={handleInputChange}
              InputProps={{
                startAdornment: <InputAdornment position="start">+ 91 </InputAdornment>,
              }}
              sx={{
                width: '250px',
                height: '56px',
                minHeight: '56px',                    
              }}
            />
          </Grid>

          {/* Second Row: 3 Columns */}
          <Grid item xs={12} sm={4}>
            <TextField fullWidth label="Email" name="email" value={formData.email} onChange={handleInputChange} 
              sx={{
                width: '250px',
                height: '56px',
                minHeight: '56px',                    
              }}
              />
          </Grid>
          <Grid item xs={12} sm={4}>
            <DatePicker
              label="Date of Birth"
              value={formData.dob}
              onChange={(newValue) => setFormData(prev => ({ ...prev, dob: newValue }))}
              renderInput={(params) => <TextField fullWidth {...params} />}
              sx={{
                width: '250px',
                height: '56px',
                minHeight: '56px',                    
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TimePicker
              label="Time of Birth"
              value={formData.tob}
              onChange={(newValue) => setFormData(prev => ({ ...prev, tob: newValue }))}
              ampm // enable 12-hour format
              renderInput={(params) => <TextField fullWidth {...params} />}
              sx={{
                width: '250px',
                height: '56px',
                minHeight: '56px',                    
              }}
            />
          </Grid>

          {/* Third Row: 3 Columns */}
          <Grid item xs={12} sm={4}>
          <FormControl fullWidth>
            <InputLabel id="gender-label">Gender</InputLabel>
            <Select
              labelId="gender-label"
              name="gender"
              value={formData.gender}
              label="Gender"
              onChange={handleInputChange}
              variant="outlined"
              sx={{
                width: '250px',
                height: '56px',
                minHeight: '56px',
                '& .MuiSelect-select': {
                  height: '56px',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0 14px',
                  fontSize: '16px'
                },
                '& .MuiInputBase-root': {
                  height: '56px'
                }
              }}
            >
              <MenuItem value="male">Male</MenuItem>
              <MenuItem value="female">Female</MenuItem>
              <MenuItem value="transgender">Transgender</MenuItem>
            </Select>
          </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField fullWidth label="Place of Birth" name="pob" value={formData.pob} onChange={handleInputChange} 
            sx={{
                width: '250px',
                height: '56px',
                minHeight: '56px',                    
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField fullWidth label="Country" name="country" value={formData.country} onChange={handleInputChange} 
            sx={{
                width: '250px',
                height: '56px',
                minHeight: '56px',                    
              }}/>
          </Grid>
        </Grid>
      </LocalizationProvider>

      <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
        <Button variant="outlined" onClick={handleCloseModal}>
          Close
        </Button>
        <Button variant="contained" onClick={handleAddUser}>
          Submit
        </Button>
      </Box>
    </Box>
  </Modal>

      {/* Edit User Modal - FIXED POSITIONING */}
      <Modal 
        open={editModalOpen} 
        onClose={() => setEditModalOpen(false)}
        sx={modalContainerStyle}
        container={document.body}
        disablePortal={false}
      >
        <Box sx={editModalContentStyle}>
          <Typography variant="h6" mb={2}>Edit User</Typography>
          {editData && (
            <Box component="form" noValidate autoComplete="off">
              <Grid container spacing={2}>
                {/* First Row: 4 Columns */}
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="First Name"
                    value={editData.firstName}
                    onChange={(e) => setEditData(prev => ({ ...prev, firstName: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="Last Name"
                    value={editData.lastName}
                    onChange={(e) => setEditData(prev => ({ ...prev, lastName: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="Email"
                    value={editData.email}
                    onChange={(e) => setEditData(prev => ({ ...prev, email: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="Date of Birth"
                    value={editData.dob}
                    onChange={(e) => setEditData(prev => ({ ...prev, dob: e.target.value }))}
                  />
                </Grid>
                
                {/* Second Row: 4 Columns */}
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="Time of Birth"
                    value={editData.tob}
                    onChange={(e) => setEditData(prev => ({ ...prev, tob: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="Place of Birth"
                    value={editData.pob}
                    onChange={(e) => setEditData(prev => ({ ...prev, pob: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="Country"
                    value={editData.country}
                    onChange={(e) => setEditData(prev => ({ ...prev, country: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="State"
                    value={editData.state}
                    onChange={(e) => setEditData(prev => ({ ...prev, state: e.target.value }))}
                  />
                </Grid>

                {/* Third Row: 4 Columns */}
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="City"
                    value={editData.city}
                    onChange={(e) => setEditData(prev => ({ ...prev, city: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="Zip Code"
                    value={editData.zipcode}
                    onChange={(e) => setEditData(prev => ({ ...prev, zipcode: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="Status"
                    value={editData.status}
                    onChange={(e) => setEditData(prev => ({ ...prev, status: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    label="User ID"
                    value={editData.userId}
                    disabled
                  />
                </Grid>
              </Grid>

              <Box display="flex" justifyContent="flex-end" mt={3}>
                <Button onClick={() => setEditModalOpen(false)}>Cancel</Button>
                <Button sx={{ ml: 2 }} variant="contained" onClick={handleUpdateUser}>Save</Button>
              </Box>
            </Box>
          )}
        </Box>
      </Modal>

      {/* Add ToastContainer at the end */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Box>
  );
}